
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 500 500","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.797 146.459C51.797 65.56 117.357 0 198.256 0c80.847 0 146.459 65.56 146.459 146.459 0 3.1-.105 6.147-.315 9.193 3.047-.21 6.094-.315 9.193-.315 80.847 0 146.407 65.56 146.407 146.46 0 80.846-65.56 146.459-146.407 146.459-29.208 0-56.419-8.563-79.271-23.324C249.317 469.742 201.408 500 146.459 500 65.612 500 0 434.44 0 353.541c0-54.949 30.311-102.858 75.12-127.863-14.76-22.799-23.323-50.011-23.323-79.219z","fill":"#000","fill-opacity":".05"}})])
          )
        }
      }
    